import React, { useEffect, useState } from 'react';
import { KompisSendByEmail } from '@inter-ikea-kompis/react-components';
import SendByEmailStateEnum from '@inter-ikea-kompis/component-send-by-email/lib/enums/SendByEmailStateEnum';
import { useSelector } from 'react-redux';
import { isLightboxOpen } from 'ducks/sheets';
import { NotificationLinkTypeEnum } from '@inter-ikea-kompis/enums/lib';
import { useServiceSettings } from 'contexts/serviceSettings';
import { isKiosk } from 'utils/platform';
import { reportShareViaEmail } from 'analytics/reporters';
import QrCode from 'components/QrCode/QrCode';
import { VpcSaveStatus, getVpcSaveStatus } from 'ducks/vpc';
import styled from 'styled-components';
import { NotificationService } from '@inter-ikea-kompis/services';
import { SkapaTheme } from '@inter-ikea-kompis/themes';

export type NotificationType = 'email' | 'qrcode';
export type Props = {
  notificationType: NotificationType;
  vpcCode: string;
  onClick?: (event: any) => void;
};

const QRBox = styled.div`
  padding: ${({ theme }) => theme.space.mdl} 0;
`;

export const SendDesign = (props: Props) => {
  const { kompisSettings, translations, dexfSettings } = useServiceSettings();
  const [inputValue, setInputValue] = useState<string>('');
  const [inputState, setInputState] = useState<SendByEmailStateEnum>(SendByEmailStateEnum.default);
  const { notificationType, vpcCode, onClick } = props;
  const isModalOpen = useSelector(isLightboxOpen);
  const vpcSaveStatus = useSelector(getVpcSaveStatus);

  useEffect(() => {
    setInputState(SendByEmailStateEnum.default);
  }, []);

  useEffect(() => {
    setInputValue('');
    setInputState(SendByEmailStateEnum.default);
  }, [notificationType]);

  useEffect(() => {
    if (!isModalOpen) {
      setInputValue('');
    }
  }, [isModalOpen]);

  const onInput = (event: any) => {
    setInputValue(event.detail.value);
  };

  const notificationService = new NotificationService(kompisSettings);
  const onSend = async () => {
    setInputState(SendByEmailStateEnum.loading);
    try {
      if (notificationType === 'email') {
        await notificationService.sendEmail({
          email: inputValue,
          vpcCode,
          linkType: NotificationLinkTypeEnum.deeplink
        });
        reportShareViaEmail();
      }
      setInputValue('');
      setInputState(SendByEmailStateEnum.success);
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(`Failed sending ${notificationType} notification`, e);
      setInputValue('');
      setInputState(SendByEmailStateEnum.failed);
    }
  };

  // TODO: [STOR-3380] use vpc save status to inform user of save in progress (here or in parent component)
  if (vpcSaveStatus !== VpcSaveStatus.Saved) {
    return null;
  }
  const savedVpcCode = vpcCode!;

  return (
    <div role="none" onClick={onClick}>
      {notificationType === 'qrcode' ? (
        <QRBox>
          <QrCode vpcCode={savedVpcCode} />
        </QRBox>
      ) : (
        <KompisSendByEmail
          theme={SkapaTheme}
          translations={translations.kompis}
          settings={dexfSettings}
          value={inputValue}
          state={inputState as any}
          onInput={onInput}
          onSend={onSend}
          disableLinks={isKiosk()}
        />
      )}
    </div>
  );
};
